// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"74af06b6","453":"2dbd0ee7"}[chunkId] + ".chunk.js";
};